import { useCallback, useEffect, useRef, useState } from 'react';
import useAskAiPromptsHistory from '@/creditflowresearch/application/AskAiPrompts/hooks/useAskAiPromptsHistory';

interface IParams {
  isEnabled: boolean,
}

const useAskAiChatPromptVersion = ({ isEnabled }: IParams) => {
  const { versions, refresh } = useAskAiPromptsHistory({ isEnabled });
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const isSelectionInitializedRef = useRef(false);
  const promptVersionIdRef = useRef<string | null>(null);

  const promptVersionId = versions.some((version) => version.id === selectedId) ? selectedId : null;

  useEffect(() => {
    if (isSelectionInitializedRef.current || !versions.length) return;

    isSelectionInitializedRef.current = true;
    setSelectedId(versions[0].id);
  }, [versions]);

  useEffect(() => {
    promptVersionIdRef.current = promptVersionId;
  }, [promptVersionId]);

  const select = useCallback((id: string | null): void => {
    isSelectionInitializedRef.current = true;
    setSelectedId(id);
  }, []);

  return { versions, selectedId: promptVersionId, select, refresh, promptVersionIdRef };
};

export default useAskAiChatPromptVersion;
